import { render, staticRenderFns } from "./submission_score_histogram_chart.vue?vue&type=template&id=53148d04&"
import script from "./submission_score_histogram_chart.vue?vue&type=script&lang=ts&"
export * from "./submission_score_histogram_chart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports